@if (teamMembers?.length > 0 && roleTitles) { @if (!hideHeader) { @if (!newProject) {
<h3>{{ teamMembers.length }} member{{ teamMembers.length == 1 ? '' : 's' }}</h3>
} @else {
<h3>Project members to add</h3>
} } @if (!newProject) {
<div class="search-members">
  <div class="input-wrapper">
    <input class="input" #searchMembers placeholder="search members" [(ngModel)]="searchText" (keyup)="onKeyup($event.code)" />
    @if (searchText) {
    <button class="iconf-btn-blank clear" matSuffix aria-label="Clear" (click)="clearSearch()">
      <mat-icon>close</mat-icon>
    </button>
    }
  </div>
  <button class="iconf-btn-filled minw50" (click)="currentSearch = searchText"><mat-icon>search</mat-icon></button>
</div>
} @if (teamMembers | FilterMembers: currentSearch; as filteredMembers) { @if (filteredMembers.length > 0) {
<div class="members-container">
  <mat-list>
    @for (member of filteredMembers; track member) {
    <mat-list-item>
      <app-project-member
        [isReadOnly]="isReadOnly"
        [member]="member"
        [roleTitles]="roleTitles"
        (updated)="updated.emit()"
        (delete)="delete.emit($event)"
      ></app-project-member>
      <mat-divider></mat-divider>
    </mat-list-item>
    }
  </mat-list>
</div>
} @else {
<p>No results matched your query</p>
} } }
